import { CardSvg } from '@/play/cardSvg'

/** Home card art: a squiggle drawn on one half, mirrored on the other, with the pink crease between. */
export function MirrorCardArt() {
  const squiggle = 'M60 150 C 70 100, 120 120, 110 80 S 140 40, 150 60'
  const blob = { x: 96, y: 140, r: 12 }
  return (
    <CardSvg bg="#f3d9e6">
      <rect x="22" y="16" width="276" height="168" rx="6" fill="#f6f1e7" />
      <line x1="160" y1="16" x2="160" y2="184" stroke="#ff3fa4" strokeWidth="4" />
      {[1, -1].map((s) => (
        <g key={s} transform={s === 1 ? undefined : 'translate(320 0) scale(-1 1)'}>
          <path d={squiggle} stroke="#3fa9f5" strokeWidth="14" strokeLinecap="round" fill="none" />
          <path d={squiggle} stroke="#2f8fd6" strokeWidth="5" strokeLinecap="round" fill="none" transform="translate(2 4)" opacity="0.5" />
          <circle cx={blob.x} cy={blob.y} r={blob.r} fill="#ffc83d" />
          <circle cx="128" cy="150" r="8" fill="#ff5a5f" />
        </g>
      ))}
    </CardSvg>
  )
}
